var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"id":"Close","to":_vm.parentOrPrevious}},[_c('svg',{attrs:{"viewBox":"0 0 100 100"}},[_c('line',{attrs:{"x1":"0","y1":"0","x2":"100","y2":"100"}}),_c('line',{attrs:{"x1":"100","y1":"0","x2":"0","y2":"100"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }